import { NgModule } from '@angular/core';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { AceCardModule } from '../UI-Lib/ACE/Card/card.module';
import { WsTypeaheadModule } from '../UI-Lib/Typeahead/typeahead.module';
import { TeamPickerComponent } from './teamPicker.component';
import { TeamsPageComponent } from './teams.page.component';
import { TeamAssignmentPanelComponent } from './Assignment/teamAssignmentPanel.component';
import { TeamService } from './team.service';

@NgModule({
    imports: [
        WeissmanSharedModule,
        AceCardModule,
        WsTypeaheadModule,
        TeamPickerComponent
    ],
    declarations: [
        TeamsPageComponent,
        TeamAssignmentPanelComponent
    ],
    exports: [
        TeamsPageComponent,
        TeamPickerComponent,
        TeamAssignmentPanelComponent
    ],
    providers: [TeamService]
})
export class TeamModule {
    static setupModule(): void {
        const hybridAdapterUtility = new HybridAdapterUtility();
        hybridAdapterUtility.downgradeNg2Component('teamsPage', TeamsPageComponent);
        hybridAdapterUtility.downgradeNg2Component('teamAssignmentPanel', TeamAssignmentPanelComponent);
        hybridAdapterUtility.downgradeNg2Component('teamPicker', TeamPickerComponent);
        hybridAdapterUtility.downgradeNg2Provider('teamsService', TeamService);
    }
}
